import MedicalHistoryTable from "./components/MedicalHistoryTable";
import { createContext, useState } from "react";
import MedicalHistorySecond from "./components/MedicalHistorySecond";
import { MedicalHistoryListType } from "./types";

export type contextType = {
  tableData: MedicalHistoryListType[];
  setTableData: (params: MedicalHistoryListType[]) => void;
  edit: MedicalHistoryListType | null;
  setEdit: (params: MedicalHistoryListType | null) => void;
  refetch:boolean;
  setRefetch:(param:boolean)=>void
};

export const MedicalHistoryContext = createContext<contextType | null>(null);

const MedicalHistory = () => {
  const [tableData, setTableData] = useState<MedicalHistoryListType[]>([]);
  const [edit, setEdit] = useState<MedicalHistoryListType | null>(null);
  const [refetch,setRefetch] = useState<boolean>(true)
  return (
    <MedicalHistoryContext.Provider
      value={{ tableData, setTableData, edit, setEdit,refetch,setRefetch }}
    >
      <div className="grid grid-cols-2 gap-3">
        <MedicalHistoryTable />
        <MedicalHistorySecond />
      </div>
    </MedicalHistoryContext.Provider>
  );
};

export default MedicalHistory;
